import { inject, Injectable } from '@angular/core';
import {
  ReleaseCalendarData,
  ReleaseCalendarQueryParams,
  releaseCalendarsResourceType
} from "../types/release-calendar-types";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { baseUrl } from "../../../../core/constants/base-url";

@Injectable({
  providedIn: 'root'
})
export class ReleaseCalendarApiService {
  private http: HttpClient = inject(HttpClient);

  public fetchReleaseCalendar(queryParams: ReleaseCalendarQueryParams): Observable<ReleaseCalendarData> {
    return this.http.get<ReleaseCalendarData>(`${baseUrl}/${releaseCalendarsResourceType}/`, { params: queryParams })
  }
}
